const jQuery = require("jquery");

const $ = jQuery;

const baseUrl = document.location.origin;
// const baseUrl = `${document.location.origin}/wordpresssmsv`;
// const baseEndpoint = "/wp-json/wp/v2/";
// const contactUrl = baseUrl + baseEndpoint + "configuracin_de_cont?per_page=100";
const contactFormContainer = document.querySelector(".contactFormContainer");

let parents = [];
let childrens = {};

const populateSelectWithParents = (items) => {
    const parentServiceSelector = $("#serviceSelector");
    parentServiceSelector.empty();
    parentServiceSelector.append(
      "<option disabled selected> Seleccione una opción </option>"
    );
  
    let childrensObject = {};
  
    for (let item of items) {
      if (!childrensObject[item.seccion]) {
        childrensObject[item.seccion] = [];
      }
      childrensObject[item.seccion].push({
        text: item.subseccion
        // email: item.email_destino,
      });
      if (!parents.includes(item.seccion)) {
        parents.push(item.seccion);
        parentServiceSelector.append(new Option(item.seccion, item.seccion));
      }
    }
    childrens = childrensObject;
  
    $("#serviceSelector").on("change", function () {
      const subServiceBlock = $("#subServiceBlock");
      subServiceBlock.show();
  
      const selectedOption = $(this).find(":selected").val();
      const availableOptions = childrens[selectedOption];
      const subServiceSelector = $("#subServiceSelector");
      subServiceSelector.empty();
      for (let opt of availableOptions) {
        subServiceSelector.append(new Option(opt.text, opt.text));
      }
      document.querySelector("#submitButton").disabled = false;
    });
};

const inputApellido = document.querySelector('#apellido');
const inputNombre = document.querySelector('#nombre');
const inputEmail = document.querySelector('#email');
const inputMatricula = document.querySelector('#matricula');
const inputDocumento = document.querySelector('#documento');
const inputComentario = document.querySelector('#comentario');
const inputMotivo = document.querySelector("#motivo");

const inputsWithErrorMsg = [
    {
        input: inputApellido, 
        msg: 'Ingrese letras solamente, sin puntos ni comas, y no más de 30 caracteres.'
    },
    {
        input: inputNombre, 
        msg: 'Ingrese letras solamente, sin puntos ni comas, y no más de 30 caracteres.'
    },
    {
        input: inputMatricula,
        msg: 'La matrícula debe contener hasta 7 dígitos.'
    },
    {
        input: inputDocumento,
        msg: 'Ingrese su documento sin puntos ni espacios.'
    }
]

const setCustomErrorMsg = (event, msg) => {
    if(event.target.value === '') {
        event.target.setCustomValidity('Esta información es obligatoria'); 
    } else {
        event.target.setCustomValidity(msg); 
    }
}

inputsWithErrorMsg.forEach(each => {
    if (each.input != null) {
        each.input.oninvalid = (event) => { setCustomErrorMsg(event, each.msg)}
        each.input.onchange = (event) => { event.target.setCustomValidity('')}
    }
})


module.exports = function saludar() {

    if (!contactFormContainer) {
        return
    }



    $('#contactForm').submit(function (e) {
        e.preventDefault();


        const inputsToCheck = [inputApellido, inputNombre, inputEmail, inputMatricula, inputDocumento, inputComentario]
        const formValid = inputsToCheck.every(i => i.checkValidity())
        if(!formValid) {
            return;

        }

        const selectedValue = $('#subServiceSelector').find(':selected').val();
        const selectedOption = $('#serviceSelector').find(':selected').val();
        const availableOptions = childrens[selectedOption];
        if(!availableOptions) {
            return 
        }

        // const childOption = availableOptions.find(a => a.text == selectedValue);

        var textToSend = `Nuevo contacto del sitio \nServicio: ${selectedOption} \nÁrea: ${selectedValue} \n`;

        $('#contactForm input, #contactForm select, #contactForm textarea').each(
            function (index) {
                var input = $(this);
                let inputName = input.attr('name');
                let inputValue = input.val();
                let invalid = ['service', 'subService']
                if (!invalid.includes(inputName)) {
                    let nameCapitalized = inputName[0].toUpperCase() + inputName.slice(1);

                    var valueCapitalized = ''
                    if (inputValue != null && inputValue != '') {
                        valueCapitalized = inputValue[0].toUpperCase() + inputValue.slice(1);;
                    }

                    textToSend += `${nameCapitalized}: ${inputValue} \n`
                }
            }
        );

        const inputMotivoText = inputMotivo.value[0].toUpperCase() + inputMotivo.value.slice(1);
        let reason = `${inputMotivoText}/${selectedOption}/${inputApellido.value}/${inputNombre.value}`;

        e.preventDefault();

        document.querySelector("#contactForm").style.opacity = 0.3;
        document.querySelector("#submitButton").disabled = true;


        $.ajax({
            url: `${baseUrl}/wp-json/customs/send_email`,
            // url: `${baseUrl}/wp-json/customs/send_email`,
            method: 'POST',
            data: {
                message: textToSend,
                reason: reason,
                // mailToSend: childOption.email,
                seccion: selectedOption,
                subseccion: selectedValue
            },
        })
        .done(function (response) {
            document.querySelector("#contactForm").remove();
            document.querySelector("#contactFormSuccess").style.display = "block";
        })
        .error(function (error) {
            document.querySelector("#contactForm").remove();
    
            document.querySelector("#contactFormError").style.display = "block";
          });
    });

    const subServiceBlock = $('#subServiceBlock');
    subServiceBlock.hide();

    const container = $('.contactFormContainer');

    var items;

    $.ajax({
        url: `${baseUrl}/wp-json/customs/configuracin_de_cont`,
        method: 'GET',
        async: false,
        statusCode: {
            400: function() {
                // rest_post_invalid_page_number -> cuando ya no hay mas registros por traer
                items = null;
            }
        }
    }).done(function (res) {
        items = res;

        populateSelectWithParents(items);
    });
}

const inputsContact = document.querySelectorAll('input');
        
const regexOnlyLetters = new RegExp(/^[\u00c4\u00e4\u00d6\u00f6\u00dc\u00fcña-zÑA-Z ']*$/);
const regexOnlyNumbers = new RegExp(/^[0-9]*$/);
const regexEmail = new RegExp(/[a-z0-9._%+-@ñÑ]$/);

inputsContact.forEach(input => {
    if (input.id == 'apellido' || input.id == 'nombre') {
        input.addEventListener('keypress', function(e) {
            if (!regexOnlyLetters.test(e.key) || this.value.length >= 30) return e.preventDefault();
        });
    }
    
    if (input.type == 'email' && input.id == 'email') {
        input.addEventListener('keypress', function(e) {
            if (!regexEmail.test(e.key)) return e.preventDefault();
        });
    }
    
    if (input.type == 'text' && input.id == 'matricula') {
        input.addEventListener('keypress', function(e) {
            if (!regexOnlyNumbers.test(e.key) || this.value.length >= 7) return e.preventDefault();
        });
    }
    
    if (input.type == 'text' && input.id == 'documento') {
        input.addEventListener('keypress', function(e) {
            if (!regexOnlyNumbers.test(e.key) || this.value.length >= 8) return e.preventDefault();
        });
    }
});


// WEBPACK FOOTER //
// ./scripts/contactForm.js